var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"choose-subscription-plan"},[(_vm.InstanceSubscriptionOptions.fetching)?_c('nuttrema-loader',{attrs:{"theme":"full-overlay"}}):_c('choose-subscription-plan',{attrs:{"email":_vm.email,"InstanceSubscriptionOptions":_vm.InstanceSubscriptionOptions},on:{"saveSelection":_vm.onSaveSelection,"previousStep":_vm.onPreviousStep}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-22aaa710","hasScoped":false,"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/professional/public/create-instance/step-2/page-create-instance-step-two.vue
// module id = 2968
// module chunks = 0